<template>
  <span
    class="inline-flex items-center gap-0.5 text-[11px] font-medium"
    :class="colorClasses">
    <svg v-if="value > 0" class="h-2 w-2" viewBox="0 0 12 12" fill="none">
      <path d="M6 2.5L10 7.5H2L6 2.5Z" fill="currentColor"/>
    </svg>
    <svg v-else-if="value < 0" class="h-2 w-2" viewBox="0 0 12 12" fill="none">
      <path d="M6 9.5L2 4.5H10L6 9.5Z" fill="currentColor"/>
    </svg>
    <svg v-else-if="showNeutral" class="h-2 w-2" viewBox="0 0 12 12" fill="none">
      <rect x="2" y="5" width="8" height="2" rx="1" fill="currentColor"/>
    </svg>
    <span>{{ label }}</span>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  /** The evolution value (positive = up, negative = down, zero = neutral) */
  value: number
  /** Pre-formatted label to display. If omitted, value is shown as-is. */
  formatted?: string
  /** Show neutral icon when value is 0 (default: false — hides entirely) */
  showNeutral?: boolean
}>(), {
  showNeutral: false,
})

const label = computed(() => props.formatted ?? String(props.value))

const colorClasses = computed(() => {
  if (props.value > 0) return 'text-emerald-500 dark:text-emerald-400'
  if (props.value < 0) return 'text-red-400 dark:text-red-400'
  return 'text-muted-foreground/60'
})
</script>
